export type UrlDefination = {
  DASHBOARD: string;
  AUTHENTICATION: {
    LOGIN: string;
    FORGOT_PASSWORD: string;
  };
  USERS: {
    USER_LIST: string;
    USER: string;
  };
  STAFF: string;
  TODO: string;
  BUYSELL: string;
  MAINTENANCE: string;
  RECEIVABLE: string;
  EXPENSE: string;
  TODAY_TASK: string;
  CONSOLE: string;
  APPOINTMENT: string;
  PROFILE: string;
  STOCK: string;
  MAPS: string;
  STATISTICS: string;
  SUPPLIER: string;
  COMPANY: string;
  CUSTOMER: {
    CUSTORMER_ADD: string;
    CUSTORMER_PROFILE: string;
    CUSTORMER_LIST: string;
  };
};

export const BASE_URLS = {
  AUTHENTICATION: "/",
  DASHBOARD: "/dashboard",
  BUYSELL: "/buysell",
  USERS: "/users",
  STAFF: "/staff",
  TODO: "/todo",
  CUSTOMER: "/customer",
  MAINTENANCE: "/maintenance",
  RECEIVABLE: "/receivable",
  EXPENSE: "/expense",
  TODAY_TASK: "/todaytask",
  CONSOLE: "/console",
  APPOINTMENT: "/appointment",
  PROFILE: "/profile",
  STOCK: "/stock",
  SUPPLIER: "/supplier",
  STATISTICS: "/statistics",
  MAPS: "/maps",
  COMPANY: "/company",
};

export default {
  DASHBOARD: `${BASE_URLS.DASHBOARD}`,
  AUTHENTICATION: {
    LOGIN: `${BASE_URLS.AUTHENTICATION}`,
    FORGOT_PASSWORD: `${BASE_URLS.AUTHENTICATION}/forgotpassword`,
  },
  USERS: {
    USER_LIST: `${BASE_URLS.USERS}/list`,
    USER: `${BASE_URLS.USERS}/profile`,
  },
  STAFF: `${BASE_URLS.STAFF}`,
  TODO: `${BASE_URLS.TODO}`,
  MAINTENANCE: `${BASE_URLS.MAINTENANCE}`,
  BUYSELL: `${BASE_URLS.BUYSELL}`,
  RECEIVABLE: `${BASE_URLS.RECEIVABLE}`,
  EXPENSE: `${BASE_URLS.EXPENSE}`,
  TODAY_TASK: `${BASE_URLS.TODAY_TASK}`,
  CONSOLE: `${BASE_URLS.CONSOLE}`,
  APPOINTMENT: `${BASE_URLS.APPOINTMENT}`,
  PROFILE: `${BASE_URLS.PROFILE}`,
  STOCK: `${BASE_URLS.STOCK}`,
  MAPS: `${BASE_URLS.MAPS}`,
  STATISTICS: `${BASE_URLS.STATISTICS}`,
  SUPPLIER: `${BASE_URLS.SUPPLIER}`,
  COMPANY: `${BASE_URLS.COMPANY}`,

  CUSTOMER: {
    CUSTORMER_ADD: `${BASE_URLS.CUSTOMER}/add`,
    CUSTORMER_PROFILE: `${BASE_URLS.CUSTOMER}/detail`,
    CUSTORMER_LIST: `${BASE_URLS.CUSTOMER}/list`,
  },
} as UrlDefination;
